import type { LookDTOType, LookGroupDTOType, LookGroupLookDTOType } from '../../../../schemas/styling';

export const getWorkspaceGeneratedImage = (look: LookGroupLookDTOType) =>
  look.image || look.generated_image_url || look.source_image_url || '';

export const getWorkspaceSourceImage = (group: LookGroupDTOType) => {
  const firstLook = Array.isArray(group.looks) ? group.looks[0] : null;
  return firstLook?.source_image_url || group.primary_look?.source_image_url || '';
};

export const getWorkspaceGeneratedAnchorImage = (group: LookGroupDTOType) => {
  const firstLook = Array.isArray(group.looks) ? group.looks[0] : null;
  return firstLook ? getWorkspaceGeneratedImage(firstLook) : getWorkspaceGeneratedImage(group.primary_look ?? ({} as LookGroupLookDTOType));
};

export const toGroupLookSummary = (look: LookDTOType): LookGroupLookDTOType => ({
  id: look.id,
  group_display_order: look.group_display_order,
  is_active: look.is_active,
  qc_status: look.qc_status,
  image_generation_status: look.image_generation_status,
  look_name: look.look_name,
  look_hook: look.look_hook,
  created_on: look.created_on,
  generated_image_url: look.generated_image_url,
  source_image_url: look.source_image_url,
  tagged_product_count: 0,
  tagged_products: [],
});
